import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HubspotFormBoxInterface } from './shared/interfaces/hubspot-form-box.interface';

@Component({
    selector: 'da-hubspot-form-box',
    templateUrl: './hubspot-form-box.component.html',
    styleUrls: ['./hubspot-form-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HubspotFormBoxComponent implements OnInit, OnChanges {
    @Input() data: HubspotFormBoxInterface;

    private _$hubspotFormBoxData: BehaviorSubject<any> = new BehaviorSubject(null);

    get hubspotFormBoxData$(): Observable<any> {
        return this._$hubspotFormBoxData.asObservable();
    }

    constructor() {}

    ngOnInit() {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes.data && changes.data.currentValue && changes.data.currentValue !== changes.data.previousValue) {
            this._$hubspotFormBoxData.next(changes.data.currentValue);
        }
    }
}
